import { Api } from 'models/services/api';
import { CreateFranchiseeQuery } from 'models/services/graphql';

import { FranchiseeData, FranchiseeDataToSave } from '../index';

type DataToCreate = {
  organizationId: string;
  input: FranchiseeDataToSave;
};

const RequestQuery = `
  mutation CreateFranchisee($organizationId: ID!, $input: FranchiseeInput!) {
    ${CreateFranchiseeQuery}
  }
`;

type ResponseData = {
  data: {
    createFranchisee: FranchiseeData
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly document?: FranchiseeData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.createFranchisee;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { CreateGql };